<div class="airline-schedule-popup">
  <div class="airline-schedule-popup-header">
    <h1 i18n="@@global.airline-schedule">Airline schedule</h1>
    <img
      src="/assets/media/icons/compare-rate/close-icon.svg"
      alt="Close"
      class="close-icon"
      (click)="closeModal()"
      style="cursor: pointer; width: 18px; height: 18px"
    />
  </div>

  <div class="airline-schedule-container">
    <div class="schedule-body">
      @if (files.length > 0) {
        <div class="schedule-info">
          <span class="file-header" i18n="@@global.Files">Files</span>
          <ul
            class="file-list"
            [ngClass]="{ 'scroll-enabled': files.length > 3 }"
          >
            @for (file of files; track file) {
              <li class="file-item">
                <div class="file-container">
                  <span
                    class="attachment-icon"
                    (click)="downloadScheduleDownload(file?.id)"
                    [style.background-image]="
                      'url(' + getIconPath(file?.name) + ')'
                    "
                  ></span>
                  <span
                    (click)="downloadScheduleDownload(file.id)"
                    class="file-name"
                    >{{ getFileName(file.name) }}</span
                  >
                </div>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>

  <div class="airline-schedule-popup-footer">
    <img
      src="/assets/media/icons/compare-rate/arrow-link-icon.svg"
      alt="Link to schedule"
      class="schedule-icon"
      [ngStyle]="{
        filter: !isScheduleUrl
          ? 'sepia(100%) saturate(0) brightness(100%)'
          : 'none',
        opacity: !isScheduleUrl ? '0.6' : '1',
      }"
      width="16"
      height="16"
    />
    <a
      i18n="@@compare-rate.airline-schedule-page"
      [ngStyle]="{
        color: isScheduleUrl ? '#7e47c5' : '#adadad',
        textDecoration: isScheduleUrl ? 'underline' : 'none',
        cursor: isScheduleUrl ? 'pointer' : 'not-allowed',
      }"
      [attr.aria-disabled]="!isScheduleUrl ? 'true' : null"
      (click)="
        !isScheduleUrl ? $event.preventDefault() : goToAirlineSchedulePage()
      "
    >
      View schedule on website
    </a>
  </div>
</div>
